import { render, staticRenderFns } from "./generalPayment.vue?vue&type=template&id=0baa28e6&"
import script from "./generalPayment.vue?vue&type=script&lang=js&"
export * from "./generalPayment.vue?vue&type=script&lang=js&"
import style0 from "./generalPayment.vue?vue&type=style&index=0&id=0baa28e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports